import { BasicRequest } from "./basicRequest";

export class EnableAuthorizedSenderEmailAddressRequest extends BasicRequest{
    
    public authorizedSenderEmailAddressId!: number;
    public enable: boolean = false;

    constructor(){
        super();
    }
}